/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerlinksempty2Inputs */

const en_organizerlinksempty2 = /** @type {(inputs: Organizerlinksempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your website and Instagram name so more people find you.`)
};

const de_organizerlinksempty2 = /** @type {(inputs: Organizerlinksempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag deine Webseite und deinen Instagram-Namen ein, dann finden dich mehr Leute.`)
};

/**
* | output |
* | --- |
* | "Add your website and Instagram name so more people find you." |
*
* @param {Organizerlinksempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerlinksempty2 = /** @type {((inputs?: Organizerlinksempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerlinksempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerlinksempty2(inputs)
	return de_organizerlinksempty2(inputs)
});
export { organizerlinksempty2 as "organizerLinksEmpty" }